import axios from "axios";
import { API_URL } from "@/config";

const store = {
  namespaced: true,

  actions: {
    async getMany(_, criteria) {
      const res = await axios.get(`${API_URL}/institutionsWorkers`, { params: criteria });

      if (!res.data || typeof res.data.items !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async getOne(_, institutionWorkerId) {
      const res = await axios.get(`${API_URL}/institutionsWorkers/${institutionWorkerId}`);

      if (!res.data || typeof res.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async create(_, institutionWorkerData) {
      const res = await axios.post(`${API_URL}/institutionsWorkers`, institutionWorkerData);

      if (res.status !== 201 || !res.data || typeof res.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async update(_, { institutionWorkerId, institutionWorkerData }) {
      const res = await axios.put(
        `${API_URL}/institutionsWorkers/${institutionWorkerId}`,
        institutionWorkerData,
      );

      if (res.status !== 200 || !res.data || typeof res.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async updateCurrentUserCardNumber(_, cardNumber) {
      const res = await axios.put(`${API_URL}/institutionsWorkers/updateCardNumber`, {
        cardNumber: cardNumber,
      });

      if (res.status !== 200) {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async updateCurrentUserInstitution(_, { institutionId, classroomId }) {
      const res = await axios.put(`${API_URL}/institutionsWorkers/updateCurrentUserInstitution`, {
        institutionId,
        classroomId,
      });

      if (res.status !== 200) {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async remove(_, institutionWorkerId) {
      const res = await axios.delete(`${API_URL}/institutionsWorkers/${institutionWorkerId}`);

      if (res.status !== 200 || !res.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },

    async activate(_, institutionWorkerId) {
      const res = await axios.post(
        `${API_URL}/institutionsWorkers/${institutionWorkerId}/activate`,
      );

      if (res.status !== 200 || !res.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },

    async deactivate(_, institutionWorkerId) {
      const res = await axios.post(
        `${API_URL}/institutionsWorkers/${institutionWorkerId}/deactivate`,
      );

      if (res.status !== 200 || !res.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },

    async archive(_, institutionsWorkers) {
      const res = await axios.post(`${API_URL}/institutionsWorkers/${institutionsWorkers}/archive`);

      if (res.status !== 200) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },

    async unarchive(_, institutionsWorkers) {
      const res = await axios.post(
        `${API_URL}/institutionsWorkers/${institutionsWorkers}/unarchive`,
      );

      if (res.status !== 200) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },

    async paymentsOverdue(_, institutionWorkerId) {
      const res = await axios.post(
        `${API_URL}/institutionsWorkers/${institutionWorkerId}/paymentsOverdue`,
      );

      if (res.status !== 200 || !res.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },
  },
};

export default store;
